import { useAppStore, type User } from '@halo/chat-sdk-react';
import { useShallowEnhance } from '@halo/zustand-enhance';

export enum RobotName {
  HaloSecurity = 'HaloSecurity',
  HaloChat = 'HaloChat',
  HaloWallet = 'HaloWallet',
}
export const useRobotInfo = (robot: User | null | undefined) => {
  const { t } = useTranslation();
  const { sessions } = useAppStore(useShallowEnhance(['sessions']));
  const session = useMemo(() => {
    return sessions.find((session) => session.user_info?.user_id === robot?.user_id);
  }, [sessions, robot?.user_id]);
  return useMemo(() => {
    switch (robot?.username) {
      case RobotName.HaloSecurity: {
        return {
          bg: robot?.background_url,
          bio: robot?.bio,
          permission: [t('profile.send_msg'), t('profile.device_recognition')],
          tooltip: t('profile.official'),
          isofficial: session?.user_info?.identifier_type === 1,
        };
      }
      case RobotName.HaloChat: {
        return {
          bg: robot?.background_url,
          bio: robot?.bio,
          permission: [t('profile.send_msg'), t('profile.read')],
          tooltip: t('profile.official'),
          isofficial: session?.user_info?.identifier_type === 1,
        };
      }
      case RobotName.HaloWallet: {
        return {
          bg: robot?.background_url,
          bio: robot?.bio,
          permission: [t('profile.send_msg'), t('profile.transaction')],
          tooltip: t('profile.official_cooperate'),
          isofficial: session?.user_info?.identifier_type === 1,
        };
      }
      default: {
        return {
          bg: robot?.background_url,
          bio: robot?.bio,
          permission: [],
          tooltip: t('profile.developer'),
          isofficial: session?.user_info?.identifier_type === 1,
        };
      }
    }
  }, [robot, session?.user_info?.identifier_type, t]);
};
